import { Link } from "react-router-dom";

import { Panel } from "./Panel";
import { useRebates } from "../hooks/useRebates";
import { accountOnlyProblem } from "../lib/accounts";
import { holdVerdict, progress, ratePercent, toneColor } from "../lib/rebates";
import { formatDollars } from "../lib/tape";
import { useCommandTarget } from "../store/useAccounts";

/**
 * Плитка тира на дашборде.
 *
 * Нужна ровно потому, что ступень теряют МОЛЧА: объём вытекает из скользящих
 * тридцати суток сам собой, и без числа на главной странице оператор узнаёт об
 * этом из сменившегося бейджа на чужом сайте. Поэтому на плитке стоит не
 * «сколько заработали», а «держится ли» — вопрос, на который надо отвечать
 * каждый день.
 */
export function RebatesTile() {
  const q = useRebates();
  const r = q.data;
  // Тир — у аккаунта: без выбора аккаунта (в том числе при когорте) раздел
  // молчал бы «загрузкой» вечно.
  const problem = accountOnlyProblem(useCommandTarget(), "тир");

  if (!r || !r.known || problem) {
    return (
      <Panel title="Возврат тейкеру" subtitle="тир программы Polymarket" dense>
        <p className="text-xs text-[var(--color-muted)]">
          {problem ?? (q.isError ? "раздел не загрузился" : (r?.reason ?? "загрузка…"))}
        </p>
      </Panel>
    );
  }

  const hold = holdVerdict(r);
  const share = progress(r);

  return (
    <Panel
      title="Возврат тейкеру"
      subtitle={`возврат ${ratePercent(r.tier.rebate_bps)} · окно ${r.window_days} суток`}
      dense
      actions={
        <Link to="/rebates" className="text-xs text-[var(--color-accent)]">
          разобрать
        </Link>
      }
    >
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-lg font-medium" style={{ color: toneColor(hold.tone) }}>
          {r.tier.name}
        </span>
        <span className="num text-xs text-[var(--color-muted)]">
          {formatDollars(r.weighted_usd)} wV{r.complete ? "" : " (занижено)"}
        </span>
      </div>

      {/* Полоса до следующей ступени. От порога НЫНЕШНЕЙ, а не от нуля: иначе
          у Gold она стояла бы почти пустой всё время, хотя ступень взята. */}
      {r.next ? (
        <>
          <div className="mt-2 h-1.5 w-full overflow-hidden rounded bg-[var(--color-border)]">
            <div
              className="h-full bg-[var(--color-accent)]"
              style={{ width: `${Math.round(share * 100)}%` }}
            />
          </div>
          <p className="mt-1.5 text-xs text-[var(--color-muted)]">
            до {r.next.name} <span className="num">{formatDollars(r.next.gap_usd)}</span> wV
          </p>
        </>
      ) : (
        <p className="mt-2 text-xs text-[var(--color-muted)]">высшая ступень</p>
      )}

      <p className="mt-2 text-xs" style={{ color: toneColor(hold.tone) }}>
        {hold.headline}
      </p>
      <p className="text-xs text-[var(--color-muted)]">{hold.detail}</p>
    </Panel>
  );
}
